var _excluded = ["size", "cell", "subRowCell", "header", "textAlign", "isSticky"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { cloneElement, isValidElement, useMemo } from 'react';
import { _TableExpandCell, _TableSelectableCell } from '../../internal';
import { Table } from '../components/Table';
import { expandColumnId } from '../components/Table/table.utils';
import { jsx as _jsx } from "react/jsx-runtime";
export var useColumnDefs = _ref => {
  var {
    columns,
    data,
    disableAllRowsSelection,
    rowSelectionTooltips,
    onRowSelectionChange,
    getRowSelectionAriaLabel,
    allRowsSelectionAriaLabel,
    onAllRowsSelectionChange,
    onRowExpandChange,
    skipToLink
  } = _ref;
  var expandColumnDef = useMemo(() => ({
    id: expandColumnId,
    header: undefined,
    cell: _ref2 => {
      var {
        row
      } = _ref2;
      return row.getCanExpand() ? /*#__PURE__*/_jsx(_TableExpandCell, {
        toggleExpanded: () => {
          onRowExpandChange === null || onRowExpandChange === void 0 ? void 0 : onRowExpandChange({
            rowId: row.id,
            isExpanded: !row.getIsExpanded()
          }); // Invoking the wrapper function in addition to the handler.

          return row.getToggleExpandedHandler()();
        },
        isExpanded: row.getIsExpanded(),
        "data-testid": "table-row-".concat(row.id, "-expand-cell")
      }) : /*#__PURE__*/_jsx(Table.Cell, {});
    },
    meta: {
      textAlign: 'start',
      size: 'xs'
    }
  }), [onRowExpandChange]);
  return useMemo(() => {
    var selectableColumnDef = {
      id: 'selectable',
      header: _ref3 => {
        var {
          table
        } = _ref3;
        return /*#__PURE__*/_jsx(_TableSelectableCell, {
          isChecked: table.getIsAllRowsSelected(),
          isIndeterminate: table.getIsSomeRowsSelected(),
          onChange: event => {
            onAllRowsSelectionChange === null || onAllRowsSelectionChange === void 0 ? void 0 : onAllRowsSelectionChange(!table.getIsAllRowsSelected()); // Invoking the wrapper function in addition to the handler.

            return table.getToggleAllRowsSelectedHandler()(event);
          },
          isDisabled: disableAllRowsSelection,
          tooltip: rowSelectionTooltips === null || rowSelectionTooltips === void 0 ? void 0 : rowSelectionTooltips.header,
          "data-testid": "table-selectable-header-cell",
          isHeader: true,
          "aria-label": allRowsSelectionAriaLabel,
          skipToLink: skipToLink
        });
      },
      cell: _ref4 => {
        var _rowSelectionTooltips;

        var {
          row
        } = _ref4;
        return /*#__PURE__*/_jsx(_TableSelectableCell, {
          isChecked: row.getIsSelected(),
          isIndeterminate: row.getIsSomeSelected(),
          onChange: event => {
            onRowSelectionChange === null || onRowSelectionChange === void 0 ? void 0 : onRowSelectionChange({
              rowId: row.id,
              rowData: row.original,
              isSelected: !row.getIsSelected()
            }); // Invoking the wrapper function in addition to the handler.

            return row.getToggleSelectedHandler()(event);
          },
          isDisabled: !row.getCanSelect(),
          tooltip: rowSelectionTooltips === null || rowSelectionTooltips === void 0 ? void 0 : (_rowSelectionTooltips = rowSelectionTooltips.row) === null || _rowSelectionTooltips === void 0 ? void 0 : _rowSelectionTooltips.call(rowSelectionTooltips, {
            rowData: row.original,
            isSelectionDisabled: !row.getCanSelect()
          }),
          "data-testid": "table-row-".concat(row.id, "-selectable-cell"),
          "aria-label": getRowSelectionAriaLabel === null || getRowSelectionAriaLabel === void 0 ? void 0 : getRowSelectionAriaLabel(row.original),
          skipToLink: skipToLink
        });
      },
      meta: {
        textAlign: 'start',
        size: 'xs'
      }
    };
    var columnDefs = columns.map(_ref5 => {
      var {
        size,
        cell: _cell,
        subRowCell,
        header,
        textAlign,
        isSticky
      } = _ref5,
          restCol = _objectWithoutProperties(_ref5, _excluded);

      return _objectSpread(_objectSpread({}, restCol), {}, {
        header: !header ? undefined : info => {
          if (header && typeof header === 'string') return /*#__PURE__*/_jsx(Table.HeaderCell, {
            textAlign: textAlign,
            children: header
          });

          if ( /*#__PURE__*/isValidElement(header)) {
            return /*#__PURE__*/cloneElement(header, {
              meta: info.table.options.meta
            });
          }

          return null;
        },
        cell: info => {
          var isSubRow = info.row.depth > 0;
          var cellElement = isSubRow ? subRowCell === null || subRowCell === void 0 ? void 0 : subRowCell({
            row: info.row.original,
            rowIndex: info.row.index,
            columnId: info.column.id,
            meta: info.table.options.meta
          }) : _cell({
            row: info.row.original,
            rowIndex: info.row.index,
            columnId: info.column.id,
            meta: info.table.options.meta
          });
          if ( /*#__PURE__*/isValidElement(cellElement)) return /*#__PURE__*/cloneElement(cellElement, {
            isLoading: info.isLoading
          });
          return /*#__PURE__*/_jsx(Table.Cell, {
            children: cellElement
          });
        },
        meta: {
          size: size ? size : 'm',
          textAlign,
          isSticky: Boolean(isSticky)
        }
      });
    });
    var sortedColumnDefs = [...columnDefs].sort((a, b) => Number(b.meta.isSticky) - Number(a.meta.isSticky));
    var actionColumnDefs = [];
    if (onRowSelectionChange || onAllRowsSelectionChange) actionColumnDefs.push(selectableColumnDef);
    var isExpandable = data.some(d => {
      var _d$subRows;

      return Boolean((_d$subRows = d.subRows) === null || _d$subRows === void 0 ? void 0 : _d$subRows.length);
    });
    if (isExpandable) actionColumnDefs.push(expandColumnDef);
    return [...actionColumnDefs, ...sortedColumnDefs];
  }, [columns, data, disableAllRowsSelection, expandColumnDef, onAllRowsSelectionChange, onRowSelectionChange, allRowsSelectionAriaLabel, getRowSelectionAriaLabel, rowSelectionTooltips, skipToLink]);
};
//# sourceMappingURL=useTable.utils.js.map